<p-multiSelect class="multi-select-custom" styleClass="custom-multi-select form-multi-select"
    dropdownIcon="icon icon-16-px-dropdown" [options]="data" (onChange)="onChangeHandler($event)"
    placeholder="{{placeholder | translate}}" [dataKey]="field" optionLabel="{{field}}" [formControl]="form"
    appendTo="body" [autoZIndex]="false" [readonly]="readonly">
    <ng-template *ngIf="selectedItemsTemplate" let-selectedObjects pTemplate="selectedItems">
        <ng-container [ngTemplateOutlet]="selectedItemsTemplate"
            [ngTemplateOutletContext]="{$implicit:selectedObjects}"></ng-container>
    </ng-template>

    <ng-template *ngIf="itemTemplate" let-obj let-i="index" pTemplate="item">
        {{obj.NAME}}ss
        <ng-container [ngTemplateOutlet]="itemTemplate" [ngTemplateOutletContext]="{$implicit:obj,index:i}">
        </ng-container>
    </ng-template>
</p-multiSelect>